/**
 * The button in the sticky bar says "Shop now" and brings the visitor back up to the main add to cart button
 * (instead of adding to the cart itself), where the offer and the shades are chosen.
 */

const STICKY_BUTTON = 'sticky-add-to-cart .sticky-add-to-cart__button';
const MAIN_BUTTON = '.product-details .product-form-buttons .add-to-cart-button';

// Capture phase on window: runs before the theme's own document-level click handling (on:click) of the sticky button.
window.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest(STICKY_BUTTON)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const main = document.querySelector(MAIN_BUTTON);
    if (!(main instanceof HTMLElement)) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    main.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  },
  true
);
